module.exports = __webpack_public_path__ + "img/stars@3x.e48b6601.png";